// Dependencies
import React, { useState, useEffect } from 'react';

// MSAL
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from 'configs/authConfig';
import { msalInstance } from "index.js";

// Components
import UnAuthorized from 'pages/UnAuthorized';

// Hooks
import { useAuthorization } from 'hooks/useAuthorization';

// Global Components
import { LoadingIndicator } from 'components/LoadingIndicator'

export const RouteGuard = ({ ...props }) => {
  const { inProgress } = useMsal();
  const { getRoles } = useAuthorization();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const currentAccount = msalInstance.getActiveAccount();

  const checkAuthorization = async () => {
    const { roles } = await getRoles();

    // if no roles given, only check for authentication
    if (!props.roles || props.roles.length === 0) {
      setIsAuthorized(true);
    } else {
      // check for authorization
      let intersection = props.roles.filter((role) => roles.includes(role));

      if (intersection.length > 0) {
        // role matched
        setIsAuthorized(true);
      } else {
        // role not matched
        setIsAuthorized(false);
      }
    }

    // prevents flashing of unauthorized component on screen
    setIsLoading(false);
  };

  useEffect(() => {
    // log in user if not already logged in
    if (inProgress === InteractionStatus.None) {
      if (!currentAccount) {
        msalInstance.loginRedirect(loginRequest).catch((e) => {
          console.error(e);
        });
      } else {
        // check for roles
        checkAuthorization();
      }
    }
  }, [msalInstance, currentAccount, inProgress]);

  return (
    <>
      {/* if authorized, show the passed in component, otherwise show the unauth component when done loading */}
      {isAuthorized ? (
        <div>{props.children}</div>
      ) : isLoading ? (
        <LoadingIndicator />
      ) : <UnAuthorized />}
    </>
  );
};
